import React from 'react';

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default (props: SvgIconProps) => (
  <SvgIcon {...props} sx={{fontSize: '1.25rem'}} viewBox="0 0 18 15">
    <path d="M18 7L11 0V4C4 5 1 10 0 15C2.5 11.5 6 9.9 11 9.9V14L18 7Z" fill="currentColor"/>
  </SvgIcon>
);
